import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './nl.json';
import en from './en.json';

const stored = localStorage.getItem('ui_language');
const initial = stored === 'en' || stored === 'nl' ? stored : 'nl';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
    },
    lng: initial,
    fallbackLng: 'nl',
    interpolation: { escapeValue: false },
  });

export default i18n;
